import { Microfrontend } from '@thoughtspot/microfrontends';
import {
    loadMicroFrontendComponent,
    loadMicroFrontendFunction,
} from './microfrontend-wrapper';

enum COMSComponents {
    ComsPreferences = 'ComsPreferences',
    UserMenuContainer = 'UserMenuContainer',
    AddToSlackContainer = 'AddToSlackContainer',
    getValidComsToken = 'getValidComsToken',
    AddToMsteamsContainer = 'AddToMsteamsContainer',
    NotificationsContainer = 'NotificationsWrapperContainer',
    AddToSlackKPIContainer = 'AddToSlackKPIContainer',
}

export const ComsPreferences = loadMicroFrontendComponent(
    Microfrontend.COMS,
    COMSComponents.ComsPreferences,
);

export const UserMenuContainer = loadMicroFrontendComponent(
    Microfrontend.COMS,
    COMSComponents.UserMenuContainer,
);

export const AddToSlackContainer = loadMicroFrontendComponent(
    Microfrontend.COMS,
    COMSComponents.AddToSlackContainer,
);

export const AddToSlackKPIContainer = loadMicroFrontendComponent(
    Microfrontend.COMS,
    COMSComponents.AddToSlackKPIContainer,
);

export const AddToMsteamsContainer = loadMicroFrontendComponent(
    Microfrontend.COMS,
    COMSComponents.AddToMsteamsContainer,
);

export const getValidComsToken = async (operationName: string) => {
    const getValidComsTokenFn = await loadMicroFrontendFunction(
        Microfrontend.COMS,
        COMSComponents.getValidComsToken,
    );
    return getValidComsTokenFn(operationName);
};

export const NotificationsContainer = loadMicroFrontendComponent(
    Microfrontend.COMS,
    COMSComponents.NotificationsContainer,
);
